import React from "react";
import Layout from "../Components/Layout";
import bg from "../assets/BGpng.jpg"

const Home = () => {
  return (
    <Layout PageId={0}>
      <div
        className="flex items-center justify-center h-screen bg-center bg-cover "
        style={{
          backgroundImage: `url(${bg})`,
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundPositionX: "50%",
          backgroundPositionY: "50%",
        }}
      >
        <div className="text-center">
          <h1 className="mb-4 text-6xl font-bold text-primary ">
            Welcome to Diksha.Online
          </h1>
         
        </div>
      </div>
    </Layout>
  );
};

export default Home;
